import { atomFamily } from "jotai/utils";

import { VehicleType } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionOtherVehicleLicensePlateAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherVehicleLicensePlate-${sessionId}`, "")
);

export const otherVehicleLicensePlateAtom = createDerivedSessionAtom<string>(sessionOtherVehicleLicensePlateAtom);

export const sessionOtherVehicleTypeAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherVehicleType-${sessionId}`, null as VehicleType | null)
);

export const otherVehicleTypeAtom = createDerivedSessionAtom<VehicleType | null>(sessionOtherVehicleTypeAtom);

const sessionOtherVehicleInsuranceAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherVehicleInsurance-${sessionId}`, "")
);

export const otherVehicleInsuranceAtom = createDerivedSessionAtom<string>(sessionOtherVehicleInsuranceAtom);

const sessionOtherDriverFirstNameAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherDriverFirstName-${sessionId}`, "")
);

export const otherDriverFirstNameAtom = createDerivedSessionAtom<string>(sessionOtherDriverFirstNameAtom);

const sessionOtherDriverLastNameAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherDriverLastName-${sessionId}`, "")
);

export const otherDriverLastNameAtom = createDerivedSessionAtom<string>(sessionOtherDriverLastNameAtom);

const sessionOtherDriverPersonalCodeAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherDriverPersonalCode-${sessionId}`, "")
);

export const otherDriverPersonalCodeAtom = createDerivedSessionAtom<string>(sessionOtherDriverPersonalCodeAtom);
